import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/DescriptionTwoTone";
// @ts-expect-error: ignoring as it is existing js file
import { saveValue, userDetailsSelector } from "@/store/slices/applicationFormSlice";
import { ApplicationFormSlice, UserDetailsState } from "@/store/slices/types/applicationFormSlice";

const LoanSummaryDemo = React.memo(() => {
  const dispatch = useDispatch();
  const { demoLoanDetailsFields } = useSelector<ApplicationFormSlice, UserDetailsState>(userDetailsSelector);
  const [allValues, setAllValue] = useState({
    loanSummary: "",
  });

  const handle = {
    onChangeField: (value: string, key: string) => {
      setAllValue({ ...allValues, [key]: value });
    },
    onBlurField: (key: string, value: string) => {
      dispatch(
        saveValue({
          demoLoanDetailsFields: { ...demoLoanDetailsFields, [key]: value },
        }),
      );
    },
  };

  return (
    <Grid
      container
      id="loanSummaryDemo"
      style={{
        margin: "0 0 30px",
        padding: "0 0 20px",
        borderBottom: "1px solid rgba(0,0,0,0.12)",
      }}
    >
      <Grid container xs={12} sm={12} md={2}>
        <DescriptionIcon style={{ marginRight: "10px" }} />
        <Typography>Summary</Typography>
      </Grid>

      <Grid
        container
        xs={12}
        sm={12}
        md={10}
        style={{
          padding: "0 0 0 10px",
        }}
      >
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="loanSummary"
            label="Summary"
            variant="filled"
            type="text"
            size="small"
            name="loanSummary"
            multiline
            minRows={5}
            maxRows={10}
            value={allValues?.loanSummary}
            onChange={(event) => handle.onChangeField(event?.target?.value, "loanSummary")}
            onBlur={(event) => handle.onBlurField("loanSummary", allValues?.loanSummary)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});

export default LoanSummaryDemo;
